/*
 * @Author: wzh
 * @LastEditTime: 2023-01-06 11:36:20
 * @Description: 国际化语言
 */

import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh";
import en from "./en";
import { currentLanguage } from "@/utils/helpers";

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: currentLanguage(),
	messages: {
		en: en,
		zh: zh,
	},
});

export default i18n;
